<template>
  <div class="flex items-end justify-end gap-[6px] text-[#0A0A0A] text-[14px] font-medium mb-[24px] mx-[24px]">
    <div class="grow text-right [&_p]:mb-[12px]">
      <p>Jumlah Order</p>
      <p>Total Biaya</p>
      <p v-if="canBeUpdated">
        Update Total Biaya
      </p>
      <p v-if="canBeUpdated">
        Selisih
      </p>
    </div>
    <div class="[&_p]:mb-[12px]">
      <p>: {{ loading ? '' : totalOrder }}</p>
      <p>: {{ originalFulfillmentFee | rupiah }}</p>
      <p v-if="canBeUpdated">
        : {{ newFulfillmentFee | rupiah }}
      </p>
      <p v-if="canBeUpdated">
        : {{ difference | rupiah }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeFee',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    canBeUpdated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      originalFulfillmentFee: 0,
      newFulfillmentFee: 0,
      difference: 0,
      totalOrder: 0,
    }
  },
  methods: {
    /**
     * Update the resume fee
     * @public exposed to the parent component via $refs
     * @param {number} data.originalFulfillmentFee - The original fulfillment fee
     * @param {number} data.newFulfillmentFee - The new fulfillment fee
     * @param {number} data.difference - The difference between the original fulfillment fee and the new fulfillment fee
     * @param {number} data.totalOrder - The total order
     */
    updateResumeFee({
      originalFulfillmentFee, newFulfillmentFee, difference, totalOrder,
    }) {
      this.originalFulfillmentFee = originalFulfillmentFee
      this.newFulfillmentFee = newFulfillmentFee === originalFulfillmentFee ? 0 : newFulfillmentFee
      this.difference = difference
      this.totalOrder = totalOrder
    },
  },
}
</script>
